<header-bar pageTitle="CMS Administrator Panel" headingClass="fa-home"></header-bar>

<div class="container mt-5">
    <div class="row">
        <div class="col-sm-12 col-md-6 offset-md-1 mt-md-0 mt-3">
        	<div class="card">
                <div class="card-header bg-primary text-white">
                    <p class="h3 mt-1 mb-1">
                        My tasks ({{userCountryTasks.length}})
                    </p>
                </div>
	        	<div class="card-body p-0"> 
                    <div class="pt-5 pb-5 text-center" *ngIf="userCountryTasks.length < 1">
                        <p class="text-muted">
                            <em>There are no tasks requring your attention</em>
                        </p>
                    </div>
                    <ul class="list-group" *ngIf="userCountryTasks.length > 0">
                        <li *ngFor="let task of userCountryTasks" class="list-group-item list-group-action justify-content-between border-left-0 border-right-0">
                            <span>
                                <p class="mb-0">
                                    <strong>
                                       {{task.countryName}}
                                    </strong>
                                </p>
                                <small class="text-muted">Requested {{task.requestedDateTime | fromnow}}</small>
                            </span>
                            <button class="btn btn-outline-info btn-sm" (click)="onUserCountryTaskClicked(task);">
                                {{task.isAtFirstWorkflowStage ? "Provide" : "Review"}} content
                            </button>
                        </li>
                    </ul>
	        	</div>
	        </div>
        </div>
        <div class="col-md-4 mt-md-0 mt-3" *featureToggle="features.ContentIsUpToDate">
            <div class="card">
                <div class="card-header text-white bg-primary">
                    <p class="h3 mt-1 mb-1">
                        Validate content
                    </p>
                </div>
                <div class="card-body">
                    <p>
                        To validate the portal is up-to-date, click the button below.
                    </p>
                    <button type="button" class="btn btn-success btn-block mb-1" (click)="onValidateContentClick()">All content is up-to-date <i class="fa fa-check ml-2"></i></button>
                    
                    <small class="text-muted" *ngIf="hasValidLastValidatedDate">
                        The site content was last validated <strong>{{formattedLastValidatedDate}}</strong>
                    </small>
                </div>
            </div>
        </div>
    </div>
</div>